var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27748 4.77748C2.61381 4.44114 3.14013 4.41057 3.511 4.68575L3.61726 4.77748L8 9.15979L12.3827 4.77748C12.7191 4.44114 13.2454 4.41057 13.6163 4.68575L13.7225 4.77748C14.0589 5.11381 14.0894 5.64013 13.8142 6.011L13.7225 6.11726L8.66989 11.1699C8.33355 11.5062 7.80724 11.5368 7.43636 11.2616L7.33011 11.1699L2.27748 6.11726C1.90751 5.74729 1.90751 5.14745 2.27748 4.77748Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownBlue);
export default __webpack_public_path__ + "static/media/dropdown-blue.8c29daf32c94d2b152842545dbdc95a7.svg";
export { ForwardRef as ReactComponent };